/* ── SAIZ GAMBAR PRODUK DALAM MOD SENARAI ──────────────────────────────────
   SATU pilihan untuk DUA tempat pelanggan melihat senarai produk: halaman
   Products dan modal "Add products" di Workspace. Satu kunci sahaja kerana
   "saiz gambar" ialah SATU idea — dua suis berasingan untuk perkara yang
   sama membuat pelanggan tertanya-tanya yang mana satu dia baru tekan.

   ⛔ Nilai ditulis HANYA bila pengguna menekan suis (`simpanSaizGambar`),
      tidak pernah daripada `useEffect`. Effect begitu turut berjalan pada
      mount, jadi setiap browser akan menyimpan nilai lalai walaupun
      penggunanya tidak pernah memilih apa-apa — dan menukar lalai selepas
      itu langsung tidak berkesan. Perangkap yang SAMA pernah berlaku pada
      kunci paparan grid/senarai (lihat nota `sesaat_products_paparan_v2`
      dalam LibraryView.jsx) dan pada kotak "Isi" jadual.

   ⚠️ DUA peta piksel, bukan satu. "Kecil" pada setiap tempat = saiz yang
      MEMANG dipakai hari ini, supaya pelanggan yang tidak menyentuh suis ini
      langsung tidak nampak apa-apa berubah. Baris dalam modal memang lebih
      rapat (tinggi modal terhad + ada troli di sebelah), jadi nombornya
      lebih kecil daripada halaman penuh. */

export const SAIZ_PILIHAN = ['s', 'm', 'l'];

export const SAIZ_SENARAI = { s: 32, m: 56, l: 88 };   // halaman Products
export const SAIZ_MODAL   = { s: 22, m: 44, l: 72 };   // modal "Add products"

/* Bucu bulat + ikon sandaran (produk tanpa gambar) diskalakan sekali —
   radius 8px pada petak 88px nampak tajam, dan ikon 11px hilang di
   tengah-tengah petak besar. */
export const SAIZ_RADIUS = { s: 6, m: 8, l: 10 };
export const SAIZ_IKON   = { s: 11, m: 18, l: 26 };

const KUNCI = 'sesaat_saiz_gambar_v1';

export const bacaSaizGambar = () => {
    try {
        const v = localStorage.getItem(KUNCI);
        return SAIZ_PILIHAN.includes(v) ? v : 's';
    } catch { return 's'; }   /* mod privasi boleh melempar ralat */
};

export const simpanSaizGambar = (v) => {
    try { localStorage.setItem(KUNCI, v); } catch { /* mod privasi */ }
};
